import React, { Fragment, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  SetSalesOrderList,
  GetSalesOrderList,
} from "../../store/salesOrderAtom";
import { purchaseService } from "../../services/purchase.service";
import { salesService } from "../../services/sales.service";
import { Combobox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { debounce } from "lodash";

// This file get all Sales Order Records
function SalesOrderReturnSearch() {
  const getSalesOrderList: any = GetSalesOrderList();
  const setSalesOrderList = SetSalesOrderList();
  const [searchResult, setSearchResult] = useState([]);
  const [textInput, setTextInput] = useState("");
  const navigate = useNavigate();
  const mountedRef = useRef(true);

  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
 

  const debouncedSearch = React.useRef(
    debounce(async (event) => {
      processSearch(event);
    }, 2000)
  ).current;

  const processSearch = (search: string) => {
    setTextInput(search);

    if (search.length < 2) {
      setSearchResult([]);
    } else {
      salesService.getSalesOrderReturnSearch(search).then(response => {
        if (response.data?.so_return_main?.length) {
          setSearchResult(response.data.so_return_main);
        }
      });
    }
  };

  function selectedOption(sales: any) {
    const { return_ref_no } = sales;
    setSearchResult([]);
    setTextInput("");
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${return_ref_no}`);
  }

  return (
    <>
      <Combobox>
        <div className="relative max-w-sm w-full">
          <div className="relative">
            <Combobox.Input
              className=" w-full rounded-full border font-medium border-gray-300 bg-white py-1.5 pl-10 pr-4 text-sm text-gray-800 placeholder-gray-400 focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600"
              placeholder="Search in Returns"
              onChange={event => debouncedSearch(event.target.value)}
            />
            <Combobox.Button className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-5 text-gray-500"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                />
              </svg>
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setTextInput('')}
          >
            <Combobox.Options className="absolute z-10 mt-2 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-black/10 focus:outline-none">
              {searchResult.length === 0 && textInput !== '' ? (
                <div className="relative cursor-default select-none px-4 py-2 text-gray-700">Nothing found.</div>
              ) : (
                searchResult.map((invoice: any, i: number) => (
                  <Combobox.Option
                    key={i}
                    onClick={() => selectedOption(invoice)}
                    className={({ active }) =>
                      `relative cursor-pointer select-none text-xs font-medium py-2 pl-10 pr-4 ${
                        active ? 'bg-gray-100 text-white' : 'text-gray-700'
                      }`
                    }
                    value={invoice}
                  >
                    {({ selected, active }) => (
                      <>
                        <span className={` ${selected ? 'font-medium' : 'font-normal'}`}>
                          {invoice.sales_order_no} |{invoice?.customer_full_name}
                        </span>
                        {selected ? (
                          <span className={`absolute inset-y-0 left-0 flex items-center pl-3 ${active ? 'text-white' : 'text-gray-700'}`}>
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </>
  );
}

export default SalesOrderReturnSearch;
